












































import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import PartyMenu from '@/components/party/PartyMenu.vue'
import { BIconMusicNoteList, BIconMusicPlayerFill, BIconPersonLinesFill, BIconSearch } from 'bootstrap-vue'
import VButton from '@/components/miniComponents/VButton.vue'
import SelectedNavBarTile from '@/components/party/SelectedNavBarTile'
import Home from '@/components/party/CurrentlyPlaying.vue'
import { ActionMethod, MutationMethod } from 'vuex'
import Queue from '@/components/party/Queue.vue'
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import { disableScroll, enableScroll } from '@/assets/DisableScroll'
import Search from '@/components/party/Search.vue'
import Library from '@/components/party/Library.vue'

  interface NavBarItem {
  title: string;
  icon: Vue.Component;
  selection: SelectedNavBarTile;
  component: Vue.Component;
}

const partyRoomModule = namespace('partyRoom')
const userModule = namespace('user')
@Component({
  components: { VButton, PartyMenu }
})
export default class Party extends Vue {
  @partyRoomModule.Getter('partyName') partyName!: string
  @partyRoomModule.Getter('partyID') partyID!: string
  @partyRoomModule.Action('mountQueue') mountQueue!: ActionMethod
  @partyRoomModule.Action('mountVotesForNext') mountVotesForNext!: ActionMethod
  @partyRoomModule.Action('fetchRoom') dispatchFetchRoom!: ActionMethod
  @userModule.Mutation('setUser') setUser!: MutationMethod

  currentTab = SelectedNavBarTile.HOME

  selectedTabComponent = Home

  menuItems: Array<NavBarItem> = [
    {
      title: 'Playing',
      icon: BIconMusicPlayerFill,
      selection: SelectedNavBarTile.HOME,
      component: Home
    },
    {
      title: 'Queue',
      icon: BIconMusicNoteList,
      selection: SelectedNavBarTile.QUEUE,
      component: Queue
    },
    {
      title: 'Search',
      icon: BIconSearch,
      selection: SelectedNavBarTile.SEARCH,
      component: Search
    },
    {
      title: 'Library',
      icon: BIconPersonLinesFill,
      selection: SelectedNavBarTile.LIBRARY,
      component: Library
    }
  ]

  @Watch('$store.state.user.hasAuthorizedSpotify')
  onAuthorized (val: boolean) {
    if (val) this.updateComponent(SelectedNavBarTile.LIBRARY, Library)
  }

  async mounted () {
    // this.mountQueue(this.partyID)
    disableScroll()
  }

  updateComponent (tab: SelectedNavBarTile, component: any) {
    this.selectedTabComponent = component
    this.currentTab = tab
    if (this.currentTab === SelectedNavBarTile.QUEUE || this.currentTab === SelectedNavBarTile.SEARCH || this.currentTab === SelectedNavBarTile.LIBRARY) enableScroll()
    else disableScroll()
  }
}
